import type { ActionMode } from "./types";

type ActionModeSelectorProps = {
  options: { id: number; name: string }[];
  value: ActionMode;
  onChange: (mode: ActionMode) => void;
  className?: string;
};

export function ActionModeSelector({
  options,
  value,
  onChange,
  className = "",
}: ActionModeSelectorProps) {
  return (
    <div className={`profile-action-mode ${className}`}>
      {options.map((mode) => (
        <button
          key={mode.id}
          type="button"
          className={`profile-action-mode__button ${
            value === mode.name ? "profile-action-mode__button--active" : ""
          }`}
          onClick={() => onChange(mode.name as ActionMode)}
        >
          {mode.name}
        </button>
      ))}
    </div>
  );
}
